import { z } from "zod";
import { ThreadAuthor } from "./author.js";
import { Document } from "./document.js";
import { FileId } from "./file.js";
import { TipTapDocSchema } from "./tiptapDoc.js";
import { User } from "./user.js";

export const DiscussionParticipant = z.object({
    id: z.number(),
    name: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    avatarUrl: z.string().nullable(),
    isPrivateEnabled: z.boolean(),
});

export const ParticipantEvent = z.object({
    user: DiscussionParticipant,
    addedAt: z.string().nullable(),
    addedBy: DiscussionParticipant.nullable(),
    removedAt: z.string().nullable(),
    removedBy: DiscussionParticipant.nullable(),
});

export const Discussion = z.object({
    id: z.number(),
    title: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    contentJson: TipTapDocSchema,
    authorId: z.number().nullable(),
    discussionId: z.number(),
    attachments: z.array(FileId).optional(),
});

export const DiscussionComment = z.object({
    id: z.number(),
    discussionId: z.number().optional(),
    attachments: z.array(Document),
    contentJson: TipTapDocSchema,
    createdAt: z.string(),
    updatedAt: z.string(),
    isEdited: z.boolean().optional(),
    author: User,
});

export const DiscussionListEntry = z.object({
    id: z.number(),
    title: z.string(),
    attachmentsCount: z.number(),
    commentsCount: z.number(),
    organizations: z.array(
        z.object({
            id: z.union([z.string(), z.number()]),
            name: z.string(),
            users: z.array(DiscussionParticipant),
        }),
    ),
    // Undefined when the discussion's thread has no live comments (e.g. every
    // comment has been soft-deleted, or the discussion was just created). Fixes
    // PORTAL-API-41 — `DiscussionService.formatDiscussionListEntry` already
    // emits `lastComment: undefined` in that case, but the schema rejected it
    // and the whole `discussions.list` response failed to parse.
    lastComment: z
        .object({
            authorId: z.number().nullable(),
            author: ThreadAuthor,
            createdAt: z.string(),
            isRead: z.boolean(),
            isAuthorPrivateEnabled: z.boolean().optional(),
        })
        .optional(),
    authorId: z.number().nullable(),
    users: z.array(DiscussionParticipant),
    userCanEdit: z.boolean(),
    isEdited: z.boolean().optional(),
    isTitleEdited: z.boolean().optional(),
});
